"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edge = void 0;
class Edge {
    constructor(startNode, endNode, distributedLoads, punctualLoads, EI) {
        this.startNode = startNode;
        this.endNode = endNode;
        this.distributedLoads = distributedLoads;
        this.punctualLoads = punctualLoads;
        this.length = Math.abs(endNode.x - startNode.x);
        this.EI = EI;
    }
}
exports.Edge = Edge;
